/**
 * Utility functions for iterators
 *
 * @module component/util/iter
 */

/**
 * Create an iterator over a range of integers
 *
 * @param {number} size
 * An integer that signals the end of the iteration
 *
 * @param {number} [start=0]
 * The integer to start the range with
 *
 * @param {number} [skip=1]
 * An integer that is the interval between returned values.
 *
 * For example, if skip is set to 2, then the following will be yielded:
 * 0, 2, 4, 6, 8...
 *
 * @yields {number}
 *
 * @example
 * // numarray will be [0, 1, 2, 3, 4]
 * let numarray = Array.from(range(5))
 *
 * // numarray will be [5, 6, 7, 8, 9]
 * numarray = Array.from(range(10, 5))
 *
 * // numarray will be [0, 2, 4, 6, 8]
 * numarray = Array.from(range(10, 0, 2))
 *
 */
export function* range(size, start = 0, skip = 1) {
    let i = start;
    while (i < size) {
        yield i;
        i += skip;
    }
}
